export default __webpack_public_path__ + "static/alexgo-2-d04e4171cdd5a882043b9b4bbe25ead2.webp";